import React from 'react';
import { AsyncComponent } from '@twigeducation/async-component';
import { WithAuthentication } from '@twigeducation/oidc-client-react';
import { Route } from 'react-router-dom';
import AccessErrorPage from '../AccessErrorPage';
import Layout from '../../layout';
import withProductSubscriptions from '../../components/withProductSubscriptions';
import AsyncComponentError from '../../components/AsyncComponentError';

const Assignments = withProductSubscriptions(props => (
    <AsyncComponent
        appName="ms-assignments-mfe"
        componentName="Assignments"
        errorComponent={AsyncComponentError}
        {...props}
    />
));

const allowedRoles = ['TEACHER', 'SCHOOL_ADMIN', 'DISTRICT_OWNER', 'TWIGADMIN'];
const routes = [
    <Route path="/assignments" key="assignments">
        <WithAuthentication
            roles={allowedRoles}
            RoleErrorComponent={() => <AccessErrorPage link="/student-dashboard/" />}
        >
            <Assignments Layout={Layout} />
        </WithAuthentication>
    </Route>,
    <Route path="/students/assignments" key="students/assignments">
        <WithAuthentication roles={['STUDENT']}>
            <Assignments Layout={Layout} />
        </WithAuthentication>
    </Route>,
];

export default routes;
